import React, {useContext, useEffect} from 'react'
import {DatePicker, Form} from "antd";
import moment from "moment";
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const dateFormat = "DD/MM/YYYY"

const OfferUpdateShippingDate = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        if (record.shippingDate) {
            form.setFieldsValue({
                [`shippingDate_${rowIndex}`]: moment(record.shippingDate, "YYYY/MM/DD")
            })
        }
    }, [rowIndex, record])

    const handleChange = () => {
        const formItem = form.getFieldsValue()
        const createNewList = replaceIndexAt(
            bidList,
            {
                ...record,
                shippingDate: formItem[`shippingDate_${rowIndex}`]._d
            },
            rowIndex
        )
        setBidList(createNewList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`shippingDate_${rowIndex}`}>
                    <DatePicker style={{minWidth: '125px'}} onChange={handleChange} format={dateFormat}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateShippingDate